import { AgentVerification, Organisation } from '@percent/admin-dashboard/api/types'

export enum AgentVerificationModal {
  APPROVE,
  REJECT,
  APPROVE_EMAIL,
  UPDATE_STATUS,
  MARK_AS_SAFE
}

export type AgentVerificationDetailsProps = {
  orgData: Organisation | null
  data: AgentVerification | null
  isLoading: boolean
  errorMessage: string | null
  refresh: () => void
  approveEmail: (payload: { id?: string }) => void
}
